import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AuthService } from '@/services/auth.service'
import Cookies from 'js-cookie'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
export const Reset = () => {
	const [email, setEmail] = useState('')
	const [code, setCode] = useState('')

	const searchParams = useSearchParams()
	const productId: string | null = searchParams.get('product_id')

	const [isEmailInput, setIsEmailInput] = useState(true)
	const [timer, setTimer] = useState(0)

	useEffect(() => {
		if (isEmailInput == false) {
			// Устанавливаем начальное значение таймера (10 минут в миллисекундах)
			const initialTime = 600_000
			setTimer(initialTime)

			const intervalId = setInterval(() => {
				setTimer(prevTimer => {
					const newTime = prevTimer - 1000

					if (newTime <= 0) {
						clearInterval(intervalId)
						setIsEmailInput(true)
						return 0
					}

					return newTime
				})
			}, 1000)

			return () => clearInterval(intervalId)
		}
	}, [isEmailInput])

	// Конвертирование из миллисекунд в "Х мин ХХ сек (10 минут = 600 000 миллисекунд)"
	const formatTime = (milliseconds: number) => {
		const totalSeconds = Math.floor(milliseconds / 1000)
		const minutes = Math.floor(totalSeconds / 60)
		const seconds = totalSeconds % 60

		// Добавляем ведущий ноль для секунд, если нужно
		const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds

		return `${minutes} мин ${formattedSeconds} сек`
	}

	function submitCode() {
		AuthService.confirmReset(email, code)
			.then(response => {
				if (response) {
					toast.success('Вход выполнен успешно!')
					// Запоминаем логин для страницы нового пароля: там он нужен
					// скрытым полем, иначе Keychain не к чему привязать пароль.
					Cookies.set('email', email, { expires: 7 })
					setTimeout(() => {
						window.location.href =
							'/auth/newpassword' +
							`${productId ? '?product_id=' + productId : ''}`
					}, 1000)
				}
			})
			.catch(error => {
				if (
					error.response?.data?.message ==
					'У вас закончились попытки, запросите код еще раз'
				) {
					setTimeout(() => {
						setIsEmailInput(true)
					}, 1000)
				}
				toast.error(error.response?.data?.message || 'Ошибка входа')
			})
	}
	function submitEmail() {
		AuthService.startReset(email)
			.then(() => setIsEmailInput(false))
			.catch(error => {
				toast.error(error.response?.data?.message || 'Ошибка входа')
			})
	}

	function onSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault()

		if (isEmailInput) {
			submitEmail()
		} else {
			submitCode()
		}
	}

	return (
		<form
			className='space-y-6 w-full max-w-md mx-auto p-6 rounded-lg shadow-lg bg-white/5 backdrop-blur-sm border border-gray-800'
			onSubmit={onSubmit}
		>
			<div className='space-y-4'>
				{isEmailInput ? (
					<div className='space-y-2'>
						<Label
							htmlFor='reset-email'
							className='text-sm font-medium text-gray-200'
						>
							Почта
						</Label>
						<Input
							id='reset-email'
							name='username'
							type='email'
							autoComplete='username'
							inputMode='email'
							placeholder='yourmail@domain.com'
							className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
							value={email}
							onChange={e => setEmail(e.target.value)}
							required
						/>
					</div>
				) : (
					<div className='space-y-2'>
						<Label
							htmlFor='reset-code'
							className='text-sm font-medium text-gray-200'
						>
							Код
						</Label>
						<Input
							id='reset-code'
							name='code'
							type='text'
							autoComplete='one-time-code'
							inputMode='numeric'
							pattern='[0-9]*'
							placeholder='✖✖✖✖'
							className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
							value={code}
							onChange={e => {
								// Разрешаем только цифры
								const value = e.target.value.replace(/\D/g, '')
								setCode(value)
							}}
							required={!isEmailInput}
						/>
					</div>
				)}
			</div>
			{!isEmailInput && (
				<div className='text-white text-sm flex items-center justify-between'>
					<p>Отправить код повторно через: </p>
					<b>{formatTime(timer)}</b>
				</div>
			)}

			<Button
				type='submit'
				className='w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-2 px-4 rounded-md transition-all duration-200 ease-in-out transform hover:scale-[1.02] active:scale-[0.98]'
			>
				{isEmailInput ? 'Получить код' : 'Отправить код'}
			</Button>
		</form>
	)
}
